var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWrk11(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 302,
    height: 115,
    viewBox: "0 0 302 115",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1244",
    "data-name": "Rectangle 1244",
    width: 98.208,
    height: 93.895,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1243",
    "data-name": "Rectangle 1243",
    width: 98.208,
    height: 93.894,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1229",
    "data-name": "Rectangle 1229",
    width: 40.366,
    height: 26.067,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-4"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1230",
    "data-name": "Rectangle 1230",
    width: 21.695,
    height: 41.058,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-5"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1231",
    "data-name": "Rectangle 1231",
    width: 29.258,
    height: 5.688,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-6"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1232",
    "data-name": "Rectangle 1232",
    width: 4.23,
    height: 17.524,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-7"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1233",
    "data-name": "Rectangle 1233",
    width: 4.228,
    height: 17.611,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-8"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1234",
    "data-name": "Rectangle 1234",
    width: 4.056,
    height: 3.304,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-9"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1235",
    "data-name": "Rectangle 1235",
    width: 3.925,
    height: 3.297,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-10"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1236",
    "data-name": "Rectangle 1236",
    width: 3.843,
    height: 3.334,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-11"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1237",
    "data-name": "Rectangle 1237",
    width: 4.366,
    height: 3.923,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-12"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1238",
    "data-name": "Rectangle 1238",
    width: 4.301,
    height: 3.93,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-13"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1239",
    "data-name": "Rectangle 1239",
    width: 37.566,
    height: 45.819,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-14"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1240",
    "data-name": "Rectangle 1240",
    width: 39.914,
    height: 22.978,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-15"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1241",
    "data-name": "Rectangle 1241",
    width: 21.46,
    height: 12.94,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-16"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1242",
    "data-name": "Rectangle 1242",
    width: 14.469,
    height: 19.018,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "wrk-11",
    transform: "translate(-140 -3895)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1228",
    "data-name": "Rectangle 1228",
    width: 302,
    height: 115,
    transform: "translate(140 3895)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Component_26_7",
    "data-name": "Component 26 \\u2013 7",
    transform: "translate(242.021 3905.371)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3091",
    "data-name": "Group 3091",
    opacity: 0
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3090",
    "data-name": "Group 3090",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3089",
    "data-name": "Group 3089",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3088",
    "data-name": "Group 3088",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3048",
    "data-name": "Group 3048",
    transform: "translate(54.402 48.343)",
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3047",
    "data-name": "Group 3047"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3046",
    "data-name": "Group 3046",
    clipPath: "url(#clip-path-3)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10788",
    "data-name": "Path 10788",
    d: "M46.473,66.183c.039-4.909.139-9.626.092-14.343-.026-2.714-.254-5.428-.461-8.137a21.072,21.072,0,0,0-.543-2.663,5.431,5.431,0,0,1,5.43.445,2.775,2.775,0,0,1,.847,2.619,8.426,8.426,0,0,1,6.022-3.457,11.036,11.036,0,0,1,5.6.473,4.109,4.109,0,0,1,2.86,3.334,7.981,7.981,0,0,1,4.894-3.495,11.427,11.427,0,0,1,6.62.037,4.713,4.713,0,0,1,3.62,4.56c.1,2.928.019,5.862.017,8.793,0,2.056-.017,4.112.008,6.168a5.745,5.745,0,0,0,.238,1.49,2.115,2.115,0,0,0,3.223,1.471l.826-.373c.055.05.109.1.164.149a5.055,5.055,0,0,1-.32.724A6.259,6.259,0,0,1,78.2,66.044a3.526,3.526,0,0,1-2.081-3.417c-.068-4.457-.112-8.915-.185-13.372a14.886,14.886,0,0,0-.193-2.386,3.246,3.246,0,0,0-2.53-2.962,4.213,4.213,0,0,0-4.392,1.2,8.073,8.073,0,0,0-1.9,4.75c-.221,3.189-.221,6.393-.377,9.587-.074,1.536-.256,3.07-.469,4.592a4.383,4.383,0,0,1-.614,1.463,1.466,1.466,0,0,1-2.259.721,3.484,3.484,0,0,1-2.164-3.438c.031-4.431.113-8.861.136-13.292a12.432,12.432,0,0,0-.275-2.693,3.848,3.848,0,0,0-6.172-2.281,5.978,5.978,0,0,0-2.566,4.771c-.141,4.294-.129,8.592-.179,12.89-.006.506,0,1.015-.014,1.521-.051,1.93-.843,2.816-2.78,2.855a15.863,15.863,0,0,1-2.707-.371",
    transform: "translate(-45.561 -40.487)",
    fill: "#040504"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3051",
    "data-name": "Group 3051",
    transform: "translate(35.942 33.355)",
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3050",
    "data-name": "Group 3050"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3049",
    "data-name": "Group 3049",
    clipPath: "url(#clip-path-4)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10789",
    "data-name": "Path 10789",
    d: "M45.241,43.233a3.576,3.576,0,0,1-.247,2.611,2.163,2.163,0,0,1-1.387,1.019c-1.4.137-2.818.048-4.316.048a6.91,6.91,0,0,0-.177.979c-.035,1.2-.048,2.4-.059,3.606q-.061,7.247-.115,14.5c-.017,2.273-.891,2.995-3.182,3a11.927,11.927,0,0,1-2.34-.429c.05-2.782.143-5.417.135-8.05-.011-3.656-.074-7.313-.162-10.968-.041-1.7-.648-3.066-2.49-3.564-.294-.079-.724-.337-.758-.562a8.259,8.259,0,0,1,.035-1.823c0-.059.215-.133.337-.147,1.833-.229,2.752-2.147,2.916-3.739a31.407,31.407,0,0,1,.757-5.429c1.087-3.789,3.813-5.752,7.685-6.227a11.183,11.183,0,0,1,7.33,1.306A4.876,4.876,0,0,1,51.8,33.349a3.8,3.8,0,0,1-.171.831c-1.772-2.2-4.025-2.7-6.485-2.675a5.606,5.606,0,0,0-5.823,4.972c-.269,2.266-.2,4.571-.291,7.057l6.216-.3",
    transform: "translate(-30.101 -27.935)",
    fill: "#040504"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3054",
    "data-name": "Group 3054",
    transform: "translate(48.064 76.959)",
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3053",
    "data-name": "Group 3053"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3052",
    "data-name": "Group 3052",
    clipPath: "url(#clip-path-5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10790",
    "data-name": "Path 10790",
    d: "M40.253,69.783a16.9,16.9,0,0,1,1.58-1.934,11.671,11.671,0,0,1,6.288-2.736,58.259,58.259,0,0,1,7.148-.61c4.43-.093,8.863-.026,13.294-.026h.921l.029.253c-.849.195-1.7.377-2.548.587q-8.008,1.993-16.011,4.01a18.537,18.537,0,0,1-2.09.752,20.02,20.02,0,0,1-3.1,0c-1.617-.056-3.233-.142-4.85-.217-.124-.006-.247-.026-.663-.074",
    transform: "translate(-40.253 -64.453)",
    fill: "#040504"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3057",
    "data-name": "Group 3057",
    transform: "translate(16.647 4.968)",
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3056",
    "data-name": "Group 3056"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3055",
    "data-name": "Group 3055",
    clipPath: "url(#clip-path-6)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10791",
    "data-name": "Path 10791",
    d: "M18.118,4.161c.024.469.053.779.054,1.088q0,6.641,0,13.282c0,2.106-.39,2.666-2.473,2.959-1.906.267-1.753.574-1.754-1.424q0-6.722,0-13.442c0-1.159.324-1.676,1.441-1.979.855-.232,1.752-.316,2.731-.484",
    transform: "translate(-13.942 -4.161)",
    fill: "#040504"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3060",
    "data-name": "Group 3060",
    transform: "translate(48.878 4.925)",
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3059",
    "data-name": "Group 3059"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3058",
    "data-name": "Group 3058",
    clipPath: "url(#clip-path-7)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10792",
    "data-name": "Path 10792",
    d: "M45.162,4.125V5.281q0,6.921,0,13.842A1.828,1.828,0,0,1,43.6,21.275c-2.54.821-2.662.736-2.662-1.856q0-6.4,0-12.8c0-1.108.272-1.6,1.315-1.914a28.938,28.938,0,0,1,2.912-.578",
    transform: "translate(-40.935 -4.125)",
    fill: "#040504"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3063",
    "data-name": "Group 3063",
    transform: "translate(39.097 4.629)",
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3062",
    "data-name": "Group 3062"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3061",
    "data-name": "Group 3061",
    clipPath: "url(#clip-path-8)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10793",
    "data-name": "Path 10793",
    d: "M34.329,7.166c-1.593.012-1.593.012-1.584-1.6.007-1.264.4-1.669,1.66-1.687.08,0,.16,0,.24,0,2.254,0,2.345.1,2.014,2.37a1.052,1.052,0,0,1-1.053.909,11.093,11.093,0,0,1-1.276.01",
    transform: "translate(-32.743 -3.877)",
    fill: "#040504"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3066",
    "data-name": "Group 3066",
    transform: "translate(77.416 23.547)",
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3065",
    "data-name": "Group 3065"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3064",
    "data-name": "Group 3064",
    clipPath: "url(#clip-path-9)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10794",
    "data-name": "Path 10794",
    d: "M66.468,23.014c-1.637,0-1.637,0-1.633-1.65,0-1.262.383-1.635,1.67-1.642.134,0,.266,0,.4,0,1.872,0,1.872,0,1.852,1.895-.01.943-.4,1.359-1.331,1.4-.318.012-.638,0-.956,0",
    transform: "translate(-64.836 -19.721)",
    fill: "#040504"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3069",
    "data-name": "Group 3069",
    transform: "translate(72.711 23.528)",
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3068",
    "data-name": "Group 3068"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3067",
    "data-name": "Group 3067",
    clipPath: "url(#clip-path-10)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10795",
    "data-name": "Path 10795",
    d: "M60.933,23.011a11.026,11.026,0,0,1,.047-2.32,1.479,1.479,0,0,1,.993-.912,17.827,17.827,0,0,1,2.731-.043,13.476,13.476,0,0,1-.05,2.487c-.061.318-.652.7-1.044.753a20.483,20.483,0,0,1-2.677.035",
    transform: "translate(-60.895 -19.705)",
    fill: "#040504"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3072",
    "data-name": "Group 3072",
    transform: "translate(48.731 -0.001)",
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3071",
    "data-name": "Group 3071",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3070",
    "data-name": "Group 3070",
    clipPath: "url(#clip-path-11)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10796",
    "data-name": "Path 10796",
    d: "M44.747,1.721a7.53,7.53,0,0,0-1.362-.5.806.806,0,0,0-.681.368.843.843,0,0,0,.238.756,2.266,2.266,0,0,0,1.01.364,8.126,8.126,0,0,0,1.2.013c.118.78-.111,1.186-.849,1.193-.854.007-1.709.024-2.561-.014a.959.959,0,0,1-.672-.325c-.277-.4-.487-.887.263-.875a7.136,7.136,0,0,1-.094-1.526,1.415,1.415,0,0,1,.592-.8,2.575,2.575,0,0,1,2.787.075.865.865,0,0,1,.134,1.273",
    transform: "translate(-40.812 0)",
    fill: "#040504"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3075",
    "data-name": "Group 3075",
    transform: "translate(16.561 0.01)",
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3074",
    "data-name": "Group 3074"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3073",
    "data-name": "Group 3073",
    clipPath: "url(#clip-path-12)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10797",
    "data-name": "Path 10797",
    d: "M17.688,1.8c-.368-.219-.669-.525-1-.556a2.781,2.781,0,0,0-1.027.34,3.508,3.508,0,0,0,.6.979c.2.173.6.134.916.156s.624,0,.937,0c.153.707-.036,1.142-.678,1.175a17.931,17.931,0,0,1-2.8-.021c-.289-.03-.562-.462-.773-.759-.035-.05.29-.353.5-.6C14,1.521,14.1.844,14.75.395a2.686,2.686,0,0,1,2.866.053A.911.911,0,0,1,17.688,1.8",
    transform: "translate(-13.87 -0.008)",
    fill: "#040504"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3078",
    "data-name": "Group 3078",
    transform: "translate(7.456 48.075)",
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3077",
    "data-name": "Group 3077"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3076",
    "data-name": "Group 3076",
    clipPath: "url(#clip-path-13)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10798",
    "data-name": "Path 10798",
    d: "M40.549,69.132c-1.889-.025-2.517.7-2.7,2.595-.25,2.621-.558,5.239-.962,7.841a7.006,7.006,0,0,1-2.136,4.288,2.117,2.117,0,0,1-3.2.1,5.269,5.269,0,0,1-1.426-2.228c-.99-3.39-.779-6.918-.964-10.4-.162-3.035-.144-6.081-.209-9.122-.014-.694-.051-1.387-.057-2.081-.021-2.455-.07-4.91-.039-7.364.036-2.72.171-5.438.214-8.156A2.808,2.808,0,0,0,27.848,42.2a8.8,8.8,0,0,0-2.017-1.109,15.75,15.75,0,0,0-8.358-.488,12.555,12.555,0,0,0-9.761,7.544,18.565,18.565,0,0,0-1.384,9.237A10.9,10.9,0,0,0,9.5,64.454c3.805,3.76,10.748,2.682,13.539-.768.15-.186.315-.361.473-.541l.24.067q0,3.921,0,7.841a35.432,35.432,0,0,0,.817,8.89c.8,3.124,2.653,5.232,5.862,5.858a14.49,14.49,0,0,0,4.349.2c2.873-.328,5.364-1.459,6.689-4.272a10.284,10.284,0,0,0,.949-2.617c.512-3.143.915-6.3,1.391-9.681-1.161-.111-2.21-.282-3.261-.3M23.1,58.176A6.749,6.749,0,0,1,21.341,61.8c-1.651,1.827-5.167,2.709-7.153-.65a12.48,12.48,0,0,1-1.679-5.285,15.267,15.267,0,0,1,1.771-9.269,6.937,6.937,0,0,1,5.179-3.745c1.85-.26,3.185.457,3.607,2.3a32.36,32.36,0,0,1,.518,4.186c.062.661.011,1.334.011,2l.153.014c-.208,2.276-.344,4.562-.651,6.826",
    transform: "translate(-6.244 -40.263)",
    fill: "#040504"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3081",
    "data-name": "Group 3081",
    transform: "translate(58.294 5.063)",
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3080",
    "data-name": "Group 3080"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3079",
    "data-name": "Group 3079",
    clipPath: "url(#clip-path-14)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10799",
    "data-name": "Path 10799",
    d: "M86.129,4.292a6.065,6.065,0,0,0-3.768.73q-4.567,2.491-9.149,4.953c-1.429.771-1.6,1.329-.793,2.734a5.835,5.835,0,0,0,.675.99.873.873,0,0,0,.593.252c2.05-.023,4.1-.1,6.148-.1a1.214,1.214,0,0,1,1.3,1.164,12.655,12.655,0,0,1,.084,1.752A1.66,1.66,0,0,1,79.3,18.516c-2.265-.05-4.531-.109-6.8-.1-2.442.01-2.615-.127-2.616-2.541q0-3.245,0-6.492c0-.369.035-.862-.54-.743a14.61,14.61,0,0,0-2.817.78,1.6,1.6,0,0,0-.664,1.213c-.072,1.867-.025,3.74-.036,5.61a7.681,7.681,0,0,1-.109,1.028A1.213,1.213,0,0,1,64.409,18.4c-1.067.017-2.136-.01-3.2,0-.653,0-.925-.244-.915-.952.039-2.591.017-5.182.013-7.774,0-.279-.032-.559-.053-.878a1.893,1.893,0,0,0-.4.049,5.847,5.847,0,0,1-3.292.288A15.639,15.639,0,0,0,53.314,8.8a4.32,4.32,0,0,0-4.485,4.57c.078,1.331.029,2.671.008,4.007a3.742,3.742,0,0,0,1.7,3.268,5.371,5.371,0,0,0,4.253.917c.457-.09.907-.209,1.365-.316.291,2.267-.336,3.175-2.481,3.639a2.818,2.818,0,0,1-.792.073c-.832-.063-1.661-.158-2.494-.241.866,1.871,3.017,2.8,5.655,2.41a5.8,5.8,0,0,0,3.113-1.522c1.3-1.192,1.169-2.77,1.162-4.346a3.263,3.263,0,0,1,.365-.048c.106,0,.211.024.318.032,2.31.166,4.628.445,6.847-.566a1.358,1.358,0,0,1,.739.045,19.571,19.571,0,0,0,3.1.62c2.642.091,5.29.043,7.934.023a11.9,11.9,0,0,0,1.984-.185,4.04,4.04,0,0,0,3.672-3.649,14.084,14.084,0,0,0,.039-1.92c0-2.437-1.071-3.914-3.44-4.411a42.606,42.606,0,0,0-4.4-.475c1.974-.855,4-1.722,6.01-2.609,1.684-.741,3.356-1.242,5.005.059a2.827,2.827,0,0,0-2.357-3.885M56.2,17.212a1.766,1.766,0,0,1-2.007,1.518c-.83-.031-1.231-.473-1.261-1.508-.036-1.251-.044-2.505-.013-3.756.035-1.352.568-1.854,1.939-1.858a10.928,10.928,0,0,1,1.356.17c0,1.871.035,3.655-.014,5.435",
    transform: "translate(-48.821 -4.241)",
    fill: "#040504"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3084",
    "data-name": "Group 3084",
    transform: "translate(25.252 9.305)",
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3083",
    "data-name": "Group 3083"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3082",
    "data-name": "Group 3082",
    clipPath: "url(#clip-path-15)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10800",
    "data-name": "Path 10800",
    d: "M42.585,8.657c0-.276-.038-.55-.06-.841a8.1,8.1,0,0,1-4.722.147A10.815,10.815,0,0,0,35.737,7.8c-2.4.074-4.427,1.544-4.528,3.6-.1,2.1-.675,4.346,1.034,6.278a36.345,36.345,0,0,1-4.732-.038A4.207,4.207,0,0,1,23.7,13.086c.013-.833.186-1.664.308-2.689a9.952,9.952,0,0,0-1.373.869c-1.879,1.709-1.986,5.607-.241,7.456a6.632,6.632,0,0,0,4.859,1.919c3.63.1,7.268.144,10.9,0,2.535-.1,4.571-1.327,4.46-4.689-.081-2.427-.014-4.86-.019-7.291m-4.1,7.961c-.021.955-.49,1.255-1.433,1.071a2.026,2.026,0,0,1-1.824-2.232c-.01-1.038-.023-2.076-.01-3.114a1.447,1.447,0,0,1,1.61-1.637c.524-.023,1.051,0,1.67,0,0,2.088.03,4-.013,5.916",
    transform: "translate(-21.148 -7.793)",
    fill: "#040504"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3087",
    "data-name": "Group 3087",
    transform: "translate(0 9.276)",
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3086",
    "data-name": "Group 3086"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3085",
    "data-name": "Group 3085",
    clipPath: "url(#clip-path-16)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10801",
    "data-name": "Path 10801",
    d: "M11.531,8.267a10.376,10.376,0,0,0-5.445-.251c-2.781.6-3.871,1.987-3.866,4.82.006,2.882.063,5.766.008,8.647A6.749,6.749,0,0,1,1.679,24.1,16.034,16.034,0,0,1,0,26.539c2.5,1.158,5.925-1.912,6.345-5.86.293,0,.531.014.767,0a31.787,31.787,0,0,0,4.2-.351,3.8,3.8,0,0,0,3.151-4.045q.013-2,0-4a3.938,3.938,0,0,0-2.931-4.01M10.376,14.25c0,.533,0,1.065,0,1.6-.008,1.462-.683,2.093-2.139,2.007-1.392-.082-1.921-.6-1.92-2,0-1.3.045-2.6.1-3.9a1.173,1.173,0,0,1,1.131-1.144c1.992-.287,2.955.187,2.831,2.155-.026.424,0,.851,0,1.278",
    transform: "translate(0 -7.769)",
    fill: "#040504"
  })))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3434",
    "data-name": "Group 3434",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3434-2",
    "data-name": "Group 3434",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11088",
    "data-name": "Path 11088",
    d: "M46.473,66.182c.039-4.909.139-9.626.092-14.343-.026-2.714-.254-5.428-.461-8.137a21.074,21.074,0,0,0-.543-2.663,5.431,5.431,0,0,1,5.43.445,2.775,2.775,0,0,1,.847,2.618,8.426,8.426,0,0,1,6.021-3.457,11.036,11.036,0,0,1,5.6.473,4.109,4.109,0,0,1,2.86,3.334,7.98,7.98,0,0,1,4.894-3.495,11.427,11.427,0,0,1,6.62.037,4.713,4.713,0,0,1,3.62,4.56c.1,2.928.019,5.861.017,8.793,0,2.056-.017,4.112.008,6.168a5.744,5.744,0,0,0,.238,1.49,2.115,2.115,0,0,0,3.223,1.471l.826-.373c.055.05.109.1.164.149a5.055,5.055,0,0,1-.32.724A6.259,6.259,0,0,1,78.2,66.044a3.526,3.526,0,0,1-2.081-3.417c-.068-4.457-.112-8.915-.185-13.372a14.886,14.886,0,0,0-.193-2.386,3.246,3.246,0,0,0-2.53-2.962,4.213,4.213,0,0,0-4.392,1.2,8.073,8.073,0,0,0-1.9,4.75c-.221,3.189-.221,6.393-.377,9.587-.074,1.536-.256,3.07-.469,4.592a4.383,4.383,0,0,1-.614,1.463,1.466,1.466,0,0,1-2.259.721,3.484,3.484,0,0,1-2.164-3.438c.031-4.431.113-8.861.136-13.292a12.432,12.432,0,0,0-.275-2.693,3.848,3.848,0,0,0-6.172-2.281,5.978,5.978,0,0,0-2.566,4.771c-.141,4.294-.129,8.592-.179,12.89-.006.506,0,1.015-.014,1.521-.051,1.93-.843,2.816-2.78,2.855a15.864,15.864,0,0,1-2.707-.371",
    transform: "translate(8.84 7.855)",
    fill: "#e73b19"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11089",
    "data-name": "Path 11089",
    d: "M45.241,43.233a3.576,3.576,0,0,1-.247,2.611,2.163,2.163,0,0,1-1.387,1.019c-1.4.137-2.818.048-4.316.048a6.91,6.91,0,0,0-.177.979c-.035,1.2-.048,2.4-.059,3.606q-.061,7.247-.115,14.5c-.017,2.273-.891,2.995-3.182,3a11.926,11.926,0,0,1-2.34-.429c.05-2.782.143-5.417.135-8.05-.011-3.656-.074-7.313-.162-10.968-.041-1.7-.648-3.066-2.49-3.564-.294-.079-.724-.337-.758-.562a8.259,8.259,0,0,1,.035-1.823c0-.059.215-.133.337-.147,1.833-.229,2.752-2.147,2.916-3.738a31.407,31.407,0,0,1,.757-5.429c1.087-3.789,3.813-5.752,7.685-6.227a11.183,11.183,0,0,1,7.33,1.306A4.876,4.876,0,0,1,51.8,33.349a3.8,3.8,0,0,1-.171.831c-1.772-2.2-4.025-2.7-6.485-2.675a5.606,5.606,0,0,0-5.823,4.972c-.269,2.266-.2,4.571-.291,7.057l6.216-.3",
    transform: "translate(5.84 5.42)",
    fill: "#e73b19"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11090",
    "data-name": "Path 11090",
    d: "M40.253,69.783a16.9,16.9,0,0,1,1.58-1.934,11.671,11.671,0,0,1,6.288-2.736,58.26,58.26,0,0,1,7.147-.61c4.43-.093,8.863-.026,13.294-.026h.921l.029.253c-.849.195-1.7.377-2.548.587q-8.008,1.993-16.011,4.01a18.538,18.538,0,0,1-2.09.752,20.019,20.019,0,0,1-3.1,0c-1.617-.056-3.233-.142-4.85-.217-.124-.006-.247-.026-.663-.074",
    transform: "translate(7.81 12.505)",
    fill: "#e73b19"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11091",
    "data-name": "Path 11091",
    d: "M18.118,4.161c.024.469.053.779.054,1.088q0,6.641,0,13.282c0,2.106-.39,2.666-2.473,2.959-1.906.267-1.753.574-1.754-1.424q0-6.722,0-13.442c0-1.159.324-1.676,1.441-1.979.855-.232,1.752-.316,2.731-.484",
    transform: "translate(2.705 0.807)",
    fill: "#e73b19"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11092",
    "data-name": "Path 11092",
    d: "M45.162,4.125V5.281q0,6.921,0,13.842A1.828,1.828,0,0,1,43.6,21.275c-2.54.821-2.661.736-2.661-1.856q0-6.4,0-12.8c0-1.108.272-1.6,1.315-1.914a28.938,28.938,0,0,1,2.912-.578",
    transform: "translate(7.942 0.8)",
    fill: "#e73b19"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11093",
    "data-name": "Path 11093",
    d: "M34.329,7.166c-1.593.012-1.593.012-1.584-1.6.007-1.264.4-1.669,1.66-1.687.08,0,.16,0,.24,0,2.254,0,2.345.1,2.014,2.37a1.052,1.052,0,0,1-1.053.909,11.093,11.093,0,0,1-1.276.01",
    transform: "translate(6.353 0.752)",
    fill: "#e73b19"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11094",
    "data-name": "Path 11094",
    d: "M66.468,23.014c-1.637,0-1.637,0-1.633-1.65,0-1.262.383-1.635,1.67-1.642.134,0,.266,0,.4,0,1.872,0,1.872,0,1.852,1.895-.01.943-.4,1.359-1.331,1.4-.318.012-.638,0-.956,0",
    transform: "translate(12.58 3.826)",
    fill: "#e73b19"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11095",
    "data-name": "Path 11095",
    d: "M60.933,23.011a11.026,11.026,0,0,1,.047-2.32,1.479,1.479,0,0,1,.993-.912,17.827,17.827,0,0,1,2.731-.043,13.476,13.476,0,0,1-.05,2.487c-.061.318-.652.7-1.044.753a20.483,20.483,0,0,1-2.677.035",
    transform: "translate(11.815 3.823)",
    fill: "#e73b19"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11096",
    "data-name": "Path 11096",
    d: "M44.747,1.721a7.529,7.529,0,0,0-1.362-.5.806.806,0,0,0-.681.368.843.843,0,0,0,.238.756,2.266,2.266,0,0,0,1.01.364,8.126,8.126,0,0,0,1.2.013c.118.78-.111,1.186-.849,1.193-.854.007-1.709.024-2.561-.014a.959.959,0,0,1-.672-.325c-.277-.4-.487-.887.263-.875a7.136,7.136,0,0,1-.094-1.526,1.415,1.415,0,0,1,.592-.8,2.575,2.575,0,0,1,2.787.075.865.865,0,0,1,.134,1.273",
    transform: "translate(7.919 0)",
    fill: "#e73b19"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11097",
    "data-name": "Path 11097",
    d: "M17.688,1.8c-.368-.219-.669-.525-1-.556a2.781,2.781,0,0,0-1.027.34,3.508,3.508,0,0,0,.6.979c.2.173.6.134.916.156s.624,0,.937,0c.153.707-.036,1.141-.678,1.175a17.931,17.931,0,0,1-2.8-.021c-.289-.03-.562-.462-.773-.759-.035-.05.29-.353.5-.6C14,1.521,14.1.844,14.75.395a2.686,2.686,0,0,1,2.866.053A.911.911,0,0,1,17.688,1.8",
    transform: "translate(2.691 0.001)",
    fill: "#e73b19"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11098",
    "data-name": "Path 11098",
    d: "M40.548,69.132c-1.889-.025-2.517.7-2.7,2.595-.25,2.621-.558,5.239-.962,7.841a7.006,7.006,0,0,1-2.136,4.288,2.117,2.117,0,0,1-3.2.1,5.269,5.269,0,0,1-1.426-2.228c-.99-3.39-.779-6.918-.964-10.4-.162-3.035-.144-6.081-.209-9.122-.014-.694-.051-1.387-.057-2.081-.021-2.455-.07-4.91-.039-7.364.036-2.72.171-5.438.214-8.156A2.808,2.808,0,0,0,27.848,42.2a8.8,8.8,0,0,0-2.017-1.109,15.75,15.75,0,0,0-8.358-.488,12.555,12.555,0,0,0-9.761,7.544,18.565,18.565,0,0,0-1.384,9.237A10.9,10.9,0,0,0,9.5,64.454c3.805,3.76,10.747,2.682,13.539-.768.15-.186.315-.361.473-.541l.24.067q0,3.921,0,7.841a35.432,35.432,0,0,0,.817,8.89c.8,3.124,2.653,5.232,5.861,5.858a14.49,14.49,0,0,0,4.349.2c2.873-.328,5.364-1.459,6.689-4.272a10.283,10.283,0,0,0,.949-2.617c.512-3.143.915-6.3,1.391-9.681-1.161-.111-2.21-.282-3.261-.3M23.1,58.176a6.749,6.749,0,0,1-1.755,3.619c-1.651,1.827-5.167,2.709-7.153-.65a12.48,12.48,0,0,1-1.679-5.285,15.267,15.267,0,0,1,1.771-9.269,6.937,6.937,0,0,1,5.178-3.744c1.85-.26,3.184.457,3.607,2.3a32.36,32.36,0,0,1,.518,4.186c.062.661.011,1.334.011,2l.153.014c-.208,2.276-.344,4.562-.651,6.826",
    transform: "translate(1.211 7.812)",
    fill: "#e73b19"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11099",
    "data-name": "Path 11099",
    d: "M86.128,4.292a6.065,6.065,0,0,0-3.768.73q-4.567,2.491-9.149,4.953c-1.429.771-1.6,1.329-.793,2.734a5.834,5.834,0,0,0,.675.99.873.873,0,0,0,.593.252c2.05-.023,4.1-.1,6.148-.1a1.214,1.214,0,0,1,1.3,1.164,12.656,12.656,0,0,1,.084,1.752A1.66,1.66,0,0,1,79.3,18.516c-2.265-.05-4.531-.109-6.8-.1-2.442.01-2.615-.127-2.616-2.541q0-3.245,0-6.492c0-.369.035-.862-.54-.743a14.61,14.61,0,0,0-2.817.78,1.6,1.6,0,0,0-.664,1.213c-.072,1.867-.025,3.74-.036,5.61a7.68,7.68,0,0,1-.109,1.028A1.213,1.213,0,0,1,64.409,18.4c-1.067.017-2.136-.01-3.2,0-.653,0-.925-.244-.915-.952.039-2.591.017-5.182.013-7.774,0-.279-.032-.559-.053-.878a1.893,1.893,0,0,0-.4.049,5.847,5.847,0,0,1-3.292.288A15.639,15.639,0,0,0,53.314,8.8a4.32,4.32,0,0,0-4.485,4.57c.078,1.331.029,2.671.008,4.007a3.742,3.742,0,0,0,1.7,3.268,5.371,5.371,0,0,0,4.253.917c.457-.09.907-.209,1.365-.316.291,2.267-.336,3.175-2.481,3.639a2.818,2.818,0,0,1-.792.073c-.832-.063-1.661-.158-2.494-.241.866,1.871,3.017,2.8,5.655,2.41a5.8,5.8,0,0,0,3.113-1.522c1.3-1.192,1.169-2.77,1.162-4.346a3.264,3.264,0,0,1,.365-.048c.106,0,.211.024.318.032,2.31.166,4.628.445,6.847-.566a1.358,1.358,0,0,1,.739.045,19.57,19.57,0,0,0,3.1.62c2.642.091,5.29.043,7.934.023a11.9,11.9,0,0,0,1.984-.185,4.04,4.04,0,0,0,3.672-3.649,14.085,14.085,0,0,0,.039-1.92c0-2.437-1.071-3.914-3.44-4.411a42.605,42.605,0,0,0-4.4-.475c1.974-.855,4-1.722,6.01-2.609,1.684-.741,3.356-1.242,5.005.059a2.827,2.827,0,0,0-2.357-3.885M56.2,17.212a1.766,1.766,0,0,1-2.007,1.518c-.83-.031-1.231-.473-1.261-1.508-.036-1.251-.044-2.505-.013-3.756.035-1.352.568-1.854,1.939-1.858a10.928,10.928,0,0,1,1.356.17c0,1.871.035,3.655-.014,5.435",
    transform: "translate(9.473 0.822)",
    fill: "#e73b19"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11100",
    "data-name": "Path 11100",
    d: "M42.584,8.657c0-.276-.038-.55-.06-.841a8.1,8.1,0,0,1-4.722.147A10.815,10.815,0,0,0,35.737,7.8c-2.4.074-4.427,1.544-4.528,3.6-.1,2.1-.675,4.346,1.034,6.278a36.344,36.344,0,0,1-4.732-.038A4.207,4.207,0,0,1,23.7,13.086c.013-.833.186-1.664.308-2.689a9.952,9.952,0,0,0-1.373.869c-1.879,1.709-1.986,5.607-.241,7.456a6.632,6.632,0,0,0,4.858,1.919c3.63.1,7.268.144,10.9,0,2.535-.1,4.571-1.327,4.46-4.689-.081-2.427-.014-4.86-.019-7.291m-4.1,7.961c-.021.955-.49,1.255-1.433,1.071a2.026,2.026,0,0,1-1.824-2.232c-.01-1.038-.023-2.076-.01-3.114a1.447,1.447,0,0,1,1.61-1.637c.524-.023,1.051,0,1.67,0,0,2.088.03,4-.013,5.916",
    transform: "translate(4.103 1.512)",
    fill: "#e73b19"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11101",
    "data-name": "Path 11101",
    d: "M11.531,8.267a10.376,10.376,0,0,0-5.445-.251c-2.781.6-3.871,1.987-3.866,4.82.006,2.882.063,5.766.008,8.647A6.749,6.749,0,0,1,1.679,24.1,16.034,16.034,0,0,1,0,26.539c2.5,1.158,5.925-1.912,6.345-5.86.293,0,.531.014.767,0a31.787,31.787,0,0,0,4.2-.351,3.8,3.8,0,0,0,3.151-4.045q.013-2,0-4a3.938,3.938,0,0,0-2.931-4.01M10.376,14.25c0,.533,0,1.065,0,1.6-.008,1.461-.683,2.093-2.139,2.007-1.392-.082-1.921-.6-1.92-2,0-1.3.045-2.6.1-3.9a1.173,1.173,0,0,1,1.131-1.144c1.992-.287,2.955.187,2.831,2.155-.026.424,0,.851,0,1.278",
    transform: "translate(0 1.507)",
    fill: "#e73b19"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWrk11);
export default __webpack_public_path__ + "static/media/wrk-11.e56ed2a48943d97a8be4a0b866b6e538.svg";
export { ForwardRef as ReactComponent };